import { AppConfig, DEFAULT_FEATURES } from 'ut-business/shared';

export const windviewConfig: AppConfig = {
  appName: 'WindView',
  appIcon: 'wind-turbine',
  appInitials: 'WV',
  features: {
    ...DEFAULT_FEATURES,
    indication: {
      columns: [
        'quickNotes',
        'viewTypeName',
        'configName',
        'positionScan',
        'positionIndex',
        'length',
        'width',
        'depth',
        'aMaxZ2D',
        'aMaxZ3D',
        'tMinZ',
        'flawType',
        'verdict',
        'details',
        'imageButton',
      ],
      detailReadings: [
        'sr',
        'ir',
        'ur',
        'zScanStart',
        'zScanEnd',
        'zIndexStart',
        'zIndexEnd',
        'zDepthStart',
        'zDepthEnd',
      ],
      flawTypes: [
        'Foreign object',
        'Porosity',
        'Thickness deviation',
        'Position deviation',
        'Bondline deviation',
        'Horizontal Void',
        'Vertical Void',
      ],
    },
    analysis: true,
    aScanBitDepth: true,
    canAlignData: true,
    canStitchData: true,
    cScanThickness: true,
    deviceManager: true,
    dgs: false,
    dynamicGateMeasurementCursor: false,
    firingSequence: true,
    gateAndTcgSyncho: true,
    inspection: true,
    materialLossReading: false,
    mergeFiles: true,
    scannerMenu: true,
    snapToMinThickness: false,
    showStickynotes: true,
    snr: false,
    tcgReferenceAmplitudeLine: false,
    tilingCanvas: true,
    zoneStatistics: false,
  },
};
